import { enumValues } from "@mm/api.meteomatics.com";

export enum ConditionOptions {
  "<" = "<",
  "<=" = "<=",
  "==" = "==",
  ">" = ">",
  ">=" = ">=",
}

export type ConditionOptionsType = {
  [key: string]: (a: number, b: number) => boolean;
};

export const ConditionExpression: ConditionOptionsType = {
  ">=": (a, b) => a >= b,
  "<=": (a, b) => a <= b,
  ">": (a, b) => a > b,
  "<": (a, b) => a < b,
  "==": (a, b) => a === b,
  "!=": (a, b) => a !== b,
};

export const evaluateExpression = (expression: keyof ConditionOptionsType, a: number, b: number) => {
  const evaluator = ConditionExpression[expression];
  return evaluator(a, b);
};

export const conditionValues = enumValues(ConditionOptions);

const CONDITION_SYMBOLS: Record<string, string> = {
  ">=": "≥",
  "<=": "≤",
  "==": "=",
  "!=": "≠",
  gt: ">",
  gte: "≥",
  lt: "<",
  lte: "≤",
  eq: "=",
  neq: "≠",
};

export function conditionSymbol(operator: string) {
  return CONDITION_SYMBOLS[operator] ?? operator;
}
